<template>
  <div class="p-the-c01-form-note-panel-shortage">
    <template v-if="compareSaleEndDate(saleEndDate)">
      <template v-if="possession > 0">
        <template v-if="creditCardEnabled">
          <template v-if="cartEmpty && count == 1 && type !== 'gift_card'">
            <div
              class="p-the-c01-form-note-panel-shortage__content p-the-c01-form-note-panel-shortage__content--credit"
            >
              <div class="p-the-c01-form-note-panel-shortage__icon">
                <IconBase
                  :width="40"
                  :height="40"
                  view-box="0 0 40 40"
                  icon-color="#000"
                >
                  <IconCreditCard />
                </IconBase>
              </div>
              <p>
                ポイントが不足しているため、不足分はクレジットカードでのお支払いが必要です。
              </p>
            </div>
          </template>
          <template v-else>
            <div class="p-the-c01-form-note-panel-shortage__content">
              ポイントが不足しているため、こちらの商品はお申込みできません
            </div>
          </template>
        </template>
        <template v-else>
          <div class="p-the-c01-form-note-panel-shortage__content">
            ポイントが不足しているため、こちらの商品はお申込みできません
          </div>
        </template>
      </template>
      <template v-else>
        <div class="p-the-c01-form-note-panel-shortage__content">
          ポイントが不足しているため、こちらの商品はお申込みできません
        </div>
      </template>
    </template>
    <template v-else>
      <div class="p-the-c01-form-note-panel-shortage__content">
        この商品は現在販売しておりません。
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconCreditCard from "@/common/components/icons/IconCreditCard.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
    possession: { type: Number, required: true, default: 0 },
    creditCardEnabled: { type: Boolean, required: false, default: false },
    cartEmpty: { type: Boolean, required: false, default: false },
    count: { type: Number, required: true, default: 0 },
    type: { type: String, required: true, default: "normal" },
    saleEndDate: { type: String, required: false, default: "" }
  },
  components: {
    IconBase,
    IconCreditCard
  }
})
export default class TheC01ItemFormNotePanelShortage extends Vue {
  possession!: any;
  creditCardEnabled!: boolean;
  cartEmpty!: boolean;
  count!: any;
  type!: any;
  saleEndDate!: string;

  compareSaleEndDate(date: any): boolean {
    if (date == "") {
      return true;
    }
    const endDate = new Date(date);
    const today = new Date();
    today.setHours(0);
    today.setMinutes(0);
    today.setSeconds(0);
    return endDate >= today;
  }
}
</script>

<style lang="scss" scoped>
.p-the-c01-form-note-panel-shortage {
  &__content {
    @include text__body--s;
    padding: rem(16);
    display: flex;
    letter-spacing: 0;
    border: px(1) solid $error;
    color: $error;
    width: 100%;
    max-width: rem(288);
    line-height: rem(16);

    &--credit {
      border: px(1) solid $common-gray-border;
      color: #4f4f4f;
      max-width: rem(310);
      align-items: center;
    }

    &__icon {
      margin-right: rem(8);
    }
  }
}
</style>
